/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Marin POST /aet/courses/{courseId}/assignments/reports — export student progress ({@link EXPORT_PROGRESS_REQUESTED}).
 *
 * @file ExportProgressService.js
 * @author Gladson Samuel S
 */

import Framework, { BaseService } from '@greenville/framework';
import {
  EXPORT_PROGRESS_REQUESTED,
  EXPORT_PROGRESS_COMPLETED,
  EXPORT_PROGRESS_FAILED
} from '../../../common/constants';
import { buildExportFilename, downloadCsvFile } from '../../../common/utils/FileDownloadUtils';

export default class ExportProgressService extends BaseService {
  constructor() {
    super(EXPORT_PROGRESS_REQUESTED, 'exportProgressStatus');
  }

  /** POST /aet/courses/{courseId}/assignments/reports */
  handleEvent(eventName, eventData = {}) {
    const {
      courseId,
      queryParams
    } = eventData;
    const { sheet } = queryParams;

    return this.getClient('marin').get(`/aet/courses/${courseId}/assignments/reports?sheet=${sheet}`);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse(response, eventData = {}) {
    const { data } = response;
    const { callback, courseId, queryParams = {} } = eventData;
    const filename = buildExportFilename(courseId, queryParams.sheet);

    downloadCsvFile(data, filename);

    Framework.getEventManager().publish(EXPORT_PROGRESS_COMPLETED, data);

    if (typeof callback === 'function') {
      callback(data);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error) {
    Framework.getEventManager().publish(EXPORT_PROGRESS_FAILED, error);
  }
}
